'use client';

import { __awaiter, __generator } from '../../_virtual/_tslib.js';
import React__default, { createContext, useContext, useReducer, useEffect } from 'react';
import { notificationReducer } from './reducer.js';
import { FILTER_TYPE } from './action.js';
import { translations } from '../translations.js';
import useFirebase from '../hooks/useFirebase/index.js';
import { ELanguage } from '../../Utils/constants.js';

var initialStore = {
    isOpen: false,
    isLoading: true,
    notifications: [],
    jobInvitationNotifications: [],
    notificationCount: 0,
    notificationBellCount: 0,
    filter: FILTER_TYPE.ALL
};
var Context = createContext({
    state: initialStore,
    props: {
        langCode: ELanguage.VI,
        config: null,
        user: null
    },
    firebase: {
        getNotification: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); }); },
        setReadNotificationItem: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); }); }
    },
    t: function (_) { return ''; },
    dispatch: function () { }
});
var useNotifyStore = function () { return useContext(Context); };
var NotificationProvider = function (props) {
    var _a = useReducer(notificationReducer, initialStore), state = _a[0], dispatch = _a[1];
    var _b = useFirebase({
        state: state,
        dispatch: dispatch,
        props: props
    }), getNotification = _b.getNotification, setReadNotificationItem = _b.setReadNotificationItem, doAuthenticate = _b.doAuthenticate;
    var t = function (text) {
        var _a;
        if (props.langCode === ELanguage.VI) {
            return (_a = translations[text]) !== null && _a !== void 0 ? _a : text;
        }
        return text;
    };
    useEffect(function () {
        var _a;
        if (!props.user || (props.user && ((_a = props.user) === null || _a === void 0 ? void 0 : _a.accessToken) === '')) {
            return;
        }
        // Re-authenticate again after user logged-in
        doAuthenticate();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.user]);
    var firebase = {
        getNotification: getNotification,
        setReadNotificationItem: setReadNotificationItem
    };
    return React__default.createElement(Context.Provider, { value: { state: state, props: props, firebase: firebase, t: t, dispatch: dispatch } }, props.children);
};

export { NotificationProvider as default, initialStore, useNotifyStore };
//# sourceMappingURL=index.js.map
